// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
}

.maintenance-container {
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
    animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.maintenance-icon {
    font-size: 80px;
    margin-bottom: 20px;
    animation: rotate 4s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.maintenance-title {
    font-size: 36px;
    font-weight: 700;
    color: #333;
    margin: 0 0 20px 0;
}

.maintenance-message {
    font-size: 18px;
    color: #666;
    margin: 0 0 10px 0;
    line-height: 1.6;
}

.maintenance-submessage {
    font-size: 16px;
    color: #999;
    margin: 0 0 40px 0;
}

.maintenance-animation {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.maintenance-animation .dot {
    width: 15px;
    height: 15px;
    background: #667eea;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
}

.maintenance-animation .dot:nth-child(1) {
    animation-delay: -0.32s;
}

.maintenance-animation .dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes bounce {
    0%, 80%, 100% {
        transform: scale(0);
        opacity: 0.5;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}

.maintenance-staff-login {
    margin-top: 30px;
    background: none;
    border: none;
    color: #999;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
}

.maintenance-staff-login:hover {
    color: #667eea;
}

.maintenance-login {
    margin-top: 30px;
    text-align: left;
}

.maintenance-login .auth-container {
    min-height: auto;
    padding: 0;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .maintenance-container {
        padding: 40px 30px;
    }

    .maintenance-icon {
        font-size: 60px;
    }

    .maintenance-title {
        font-size: 28px;
    }

    .maintenance-message {
        font-size: 16px;
    }

    .maintenance-submessage {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MaintenancePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".maintenance-page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    padding: 20px;\n}\n\n.maintenance-container {\n    text-align: center;\n    background: white;\n    padding: 60px 40px;\n    border-radius: 20px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    max-width: 500px;\n    width: 100%;\n    animation: fadeIn 0.5s ease-in;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.maintenance-icon {\n    font-size: 80px;\n    margin-bottom: 20px;\n    animation: rotate 4s linear infinite;\n}\n\n@keyframes rotate {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.maintenance-title {\n    font-size: 36px;\n    font-weight: 700;\n    color: #333;\n    margin: 0 0 20px 0;\n}\n\n.maintenance-message {\n    font-size: 18px;\n    color: #666;\n    margin: 0 0 10px 0;\n    line-height: 1.6;\n}\n\n.maintenance-submessage {\n    font-size: 16px;\n    color: #999;\n    margin: 0 0 40px 0;\n}\n\n.maintenance-animation {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.maintenance-animation .dot {\n    width: 15px;\n    height: 15px;\n    background: #667eea;\n    border-radius: 50%;\n    animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.maintenance-animation .dot:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.maintenance-animation .dot:nth-child(2) {\n    animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n    0%, 80%, 100% {\n        transform: scale(0);\n        opacity: 0.5;\n    }\n    40% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.maintenance-staff-login {\n    margin-top: 30px;\n    background: none;\n    border: none;\n    color: #999;\n    font-size: 14px;\n    cursor: pointer;\n    text-decoration: underline;\n    padding: 0;\n}\n\n.maintenance-staff-login:hover {\n    color: #667eea;\n}\n\n.maintenance-login {\n    margin-top: 30px;\n    text-align: left;\n}\n\n.maintenance-login .auth-container {\n    min-height: auto;\n    padding: 0;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n    .maintenance-container {\n        padding: 40px 30px;\n    }\n\n    .maintenance-icon {\n        font-size: 60px;\n    }\n\n    .maintenance-title {\n        font-size: 28px;\n    }\n\n    .maintenance-message {\n        font-size: 16px;\n    }\n\n    .maintenance-submessage {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
